module.exports = __webpack_public_path__ + "img/course.cb3055a8.svg";